    package com.cybersoftsolution.cybersoftsolutionweb.pages.admin

    import androidx.compose.runtime.Composable
    import androidx.compose.runtime.getValue
    import androidx.compose.runtime.mutableStateOf
    import androidx.compose.runtime.remember
    import androidx.compose.runtime.rememberCoroutineScope
    import androidx.compose.runtime.setValue
    import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.CloseButtonX
    import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.LoginButton
    import com.cybersoftsolution.cybersoftsolutionweb.components.checkbox.MyCheckBox
    import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.InputTypeHTML
    import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.MyTextField
    import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
    import com.cybersoftsolution.cybersoftsolutionweb.navigation.Screen
    import com.cybersoftsolution.cybersoftsolutionweb.styles.LoginStyle
    import com.cybersoftsolution.cybersoftsolutionweb.use_cases.logInUseCase
    import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
    import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.getRememberedLogin
    import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.getUserEmailIfRemembered
    import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst
    import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.forgotPasswordText
    import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.passwordTextFieldId
    import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.userEmailTextField
    import com.varabyte.kobweb.compose.css.FontSize
    import com.varabyte.kobweb.compose.css.FontWeight
    import com.varabyte.kobweb.compose.css.TextAlign
    import com.varabyte.kobweb.compose.foundation.layout.Arrangement
    import com.varabyte.kobweb.compose.foundation.layout.Box
    import com.varabyte.kobweb.compose.foundation.layout.Column
    import com.varabyte.kobweb.compose.ui.Alignment
    import com.varabyte.kobweb.compose.ui.Modifier
    import com.varabyte.kobweb.compose.ui.graphics.Colors
    import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
    import com.varabyte.kobweb.compose.ui.modifiers.border
    import com.varabyte.kobweb.compose.ui.modifiers.color
    import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
    import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
    import com.varabyte.kobweb.compose.ui.modifiers.fontSize
    import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
    import com.varabyte.kobweb.compose.ui.modifiers.id
    import com.varabyte.kobweb.compose.ui.modifiers.margin
    import com.varabyte.kobweb.compose.ui.modifiers.padding
    import com.varabyte.kobweb.compose.ui.modifiers.textAlign
    import com.varabyte.kobweb.compose.ui.modifiers.width
    import com.varabyte.kobweb.core.Page
    import com.varabyte.kobweb.core.PageContext
    import com.varabyte.kobweb.core.rememberPageContext
    import com.varabyte.kobweb.navigation.OpenLinkStrategy
    import com.varabyte.kobweb.navigation.UpdateHistoryMode
    import com.varabyte.kobweb.silk.components.graphics.Image
    import com.varabyte.kobweb.silk.components.text.SpanText
    import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
    import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
    import kotlinx.browser.document
    import kotlinx.coroutines.CoroutineScope
    import org.jetbrains.compose.web.css.LineStyle
    import org.jetbrains.compose.web.css.percent
    import org.jetbrains.compose.web.css.px
    import org.w3c.dom.HTMLInputElement




    @Composable
    @Page(routeOverride = "login")
    fun Login(){

        val scope = rememberCoroutineScope()
        val context = rememberPageContext()
        var userName by remember { mutableStateOf(getUserEmailIfRemembered()) }
        var password by remember { mutableStateOf("") }
        var errorText by remember { mutableStateOf(" ") }


        val breakpoint = rememberBreakpoint()

        if(breakpoint >= Breakpoint.MD) {
            DesktopLogin(
                scope = scope,
                context = context,
                userName = userName,
                password = password,
                setUsername = {userName = it},
                setPassword = {password = it},
                errorText = errorText,
                setErrorText = {errorText = it}
            )
        } else {
            MobileLogin(
                scope = scope,
                context = context,
                userName = userName,
                password = password,
                setUsername = {userName = it},
                setPassword = {password = it},
                errorText = errorText,
                setErrorText = {errorText = it}
            )
        }

    }


    @Composable
    inline fun DesktopLogin(
        scope: CoroutineScope,
        context: PageContext,
        userName: String,
        password: String,
        errorText: String = " ",
        crossinline setUsername: (String) -> Unit,
        crossinline setPassword: (String) -> Unit,
        crossinline setErrorText: (String) -> Unit,
    ){

        Box(
            modifier = Modifier
                .backgroundColor(Theme.DarkGray.rgb)
                .fillMaxSize(),
            contentAlignment = Alignment.Center
        ) {
            Column(
                modifier = Modifier
                    .backgroundColor(Theme.LightGray.rgb)
                    .border(
                        width = 2.px,
                        style = LineStyle.Outset,
                        color = Theme.Primary.rgb
                    )

            ) {

                CloseButtonX {
                    context.router.navigateTo(
                        Screen.Root.route,
                        UpdateHistoryMode.REPLACE,
                        OpenLinkStrategy.IN_PLACE,
                    )
                }

                Column(
                    verticalArrangement = Arrangement.Center,
                    horizontalAlignment = Alignment.CenterHorizontally,
                    modifier = Modifier
                        .padding(leftRight = 50.px, top = 80.px, bottom = 80.px)
                ) {


                    Image(
                        modifier = Modifier
                            .width(600.px)
                            .margin(bottom = 24.px),
                        src = Resources.Images.banner,
                        alt = "Banner Image",
                    )

                    Column(
                        verticalArrangement = Arrangement.Center,
                        horizontalAlignment = Alignment.Start,
                        modifier = Modifier
                    ){

                        MyTextField(
                            text = userName,
                            style = LoginStyle,
                            inputTypeHTML = InputTypeHTML.Text,
                            id = userEmailTextField,
                            placeholder = "Usuario",
                            onChange = { setUsername(it) },
                            onEnter = {
                               (document.getElementById(passwordTextFieldId) as HTMLInputElement).focus();
                            }

                        )

                        MyTextField(
                            text = password,
                            style = LoginStyle,
                            inputTypeHTML = InputTypeHTML.Password,
                            id = passwordTextFieldId,
                            placeholder = "Contraseña",
                            onChange = {
                                setPassword(it) },
                            onEnter = {
                                scope.logInUseCase(
                                    remember = (document.getElementById(IdConst.checkBoxRememberLogin) as HTMLInputElement).checked,
                                    asAdmin = true,
                                    userName = userName,
                                    password = password,
                                    setErrorText = {setErrorText(it)},
                                    onLoginSuccess = {
                                        context.router.navigateTo(
                                            Screen.AdminHome.route,
                                            UpdateHistoryMode.REPLACE,
                                            OpenLinkStrategy.IN_PLACE,
                                        )
                                    }
                                )
                            }
                        )


                        MyCheckBox(
                            text = "Recordarme",
                            checked = getRememberedLogin(),
                            onClick = {},
                            modifier = Modifier
                                .margin(bottom = 24.px)
                        )


                        LoginButton {
                            scope.logInUseCase(
                                remember = (document.getElementById(IdConst.checkBoxRememberLogin) as HTMLInputElement).checked,
                                asAdmin = true,
                                userName = userName,
                                password = password,
                                setErrorText = {setErrorText(it)},
                                onLoginSuccess = {
                                    context.router.navigateTo(
                                        Screen.AdminHome.route,
                                        UpdateHistoryMode.REPLACE,
                                        OpenLinkStrategy.IN_PLACE,
                                    )
                                }
                            )
                        }


                        SpanText(
                            text = errorText,
                            modifier = Modifier
                                .fillMaxWidth()
                                .textAlign(TextAlign.Center)
                                .id(forgotPasswordText)
                                .color(Colors.Red)
                                .padding(leftRight = 24.px)
                                .margin(bottom = 24.px)
                                .fontWeight(FontWeight.Light)
                                .fontSize(FontSize.Medium)

                        )


                    }

                }
            }




        }
    }




    @Composable
    inline fun MobileLogin(
        scope: CoroutineScope,
        context: PageContext,
        userName: String,
        password: String,
        errorText: String = " ",
        crossinline setUsername: (String) -> Unit,
        crossinline setPassword: (String) -> Unit,
        crossinline setErrorText: (String) -> Unit,
    ){

        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Theme.LightGray.rgb)

        ) {
            Column(
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier
                    .fillMaxSize()
            ) {

                CloseButtonX {
                    context.router.navigateTo(
                        Screen.Root.route,
                        UpdateHistoryMode.REPLACE,
                        OpenLinkStrategy.IN_PLACE,
                    )
                }

                Column(
                    verticalArrangement = Arrangement.Center,
                    horizontalAlignment = Alignment.CenterHorizontally,
                ) {
                    Image(
                        modifier = Modifier
                            .width(80.percent)
                            .margin(bottom = 24.px),
                        src = Resources.Images.banner,
                        alt = "Banner Image",
                    )

                    Column(
                        verticalArrangement = Arrangement.Center,
                        horizontalAlignment = Alignment.Start,
                        modifier = Modifier
                    ){

                        MyTextField(
                            text = userName,
                            style = LoginStyle,
                            inputTypeHTML = InputTypeHTML.Text,
                            id = userEmailTextField,
                            placeholder = "Usuario",
                            onChange = { setUsername(it) },
                            onEnter = {
                                (document.getElementById(passwordTextFieldId) as HTMLInputElement).focus();
                            }
                        )

                        MyTextField(
                            text = password,
                            style = LoginStyle,
                            inputTypeHTML = InputTypeHTML.Password,
                            id = passwordTextFieldId,
                            placeholder = "Contraseña",
                            onChange = { setPassword(it) },
                            onEnter = {
                                scope.logInUseCase(
                                    remember = (document.getElementById(IdConst.checkBoxRememberLogin) as HTMLInputElement).checked,
                                    asAdmin = true,
                                    userName = userName,
                                    password = password,
                                    setErrorText = {setErrorText(it)},
                                    onLoginSuccess = {
                                        context.router.navigateTo(
                                            Screen.AdminHome.route,
                                            UpdateHistoryMode.REPLACE,
                                            OpenLinkStrategy.IN_PLACE,
                                        )
                                    }
                                )
                            }
                        )


                        MyCheckBox(
                            text = "Recordarme",
                            checked = getRememberedLogin(),
                            onClick = {},
                            modifier = Modifier
                                .margin(bottom = 24.px)
                        )


                        LoginButton {
                            scope.logInUseCase(
                                remember = (document.getElementById(IdConst.checkBoxRememberLogin) as HTMLInputElement).checked,
                                asAdmin = true,
                                userName = userName,
                                password = password,
                                setErrorText = {setErrorText(it)},
                                onLoginSuccess = {
                                    context.router.navigateTo(
                                        Screen.AdminHome.route,
                                        UpdateHistoryMode.REPLACE,
                                        OpenLinkStrategy.IN_PLACE,
                                    )
                                }
                            )
                        }


                        SpanText(
                            text = errorText,
                            modifier = Modifier
                                .fillMaxWidth()
                                .textAlign(TextAlign.Center)
                                .id(forgotPasswordText)
                                .color(Colors.Red)
                                .padding(leftRight = 24.px)
                                .margin(bottom = 24.px)
                                .fontWeight(FontWeight.Light)
                                .fontSize(FontSize.Medium)

                        )


                    }

                }
            }




        }
    }
